import { useQuery } from '@tanstack/react-query';

import { CategoriesApi } from '../../apis';
import { QueryKeys } from '../query-keys';

const useCategories = (page = 1, perPage = 10, search = '') => {
  const query = useQuery({
    queryKey: [QueryKeys.CATEGORIES, page, perPage, search],
    queryFn: () => CategoriesApi.getPage({ page, perPage, search }),
  });

  return {
    isLoading: query.isPending,
    hasError: query.isError,
    page: query.data?.page || 1,
    perPage: query.data?.perPage || 10,
    total: query.data?.total || 0,
    totalPages: query.data?.totalPages || 0,
    categories: query.data?.categories || [],
  };
};

export default useCategories;
